import React from "react";
import Header from "components/headers/lp-header";
import Footer from "components/footers/lp-footer";
import Showroom from "components/showroom/Showroom";

export default () => {
  return (
    <>
      <Header />
      <div>
        <Showroom />
        <div className="spacer" />
      </div>
      <Footer />
    </>
  );
};
